import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import { CompanyService } from '../../@core/data/company/company.service';
import { AppendixesError, AppendixesLoaded, AppendixesRequested } from './appendix.actions';
import { AppendixTypesRequested, AppendixTypesLoaded, AppendixTypesError } from './appendix.actions';

@Injectable()
export class AppendixesEffects {
  constructor(
    private actions$: Actions,
    private companyService: CompanyService
  ) {}

  requestAppendixes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppendixesRequested),
      mergeMap(() =>
        this.companyService.getCompanyAppendixes().pipe(
          map((res: any) => {
            return res.status ? AppendixesLoaded({ appendixes: res?.data }) : AppendixesLoaded({appendixes: []})
        }),
          catchError((error: any) => of(AppendixesError()))
        ) 
      )
    )
  );

  requestAppendixTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppendixTypesRequested),
      mergeMap(() =>
        this.companyService.getCompanyAppendixTypes().pipe(
          map((res: any) => {
            return res.status ? AppendixTypesLoaded({ appendixTypes: res?.data }) : AppendixTypesLoaded({appendixTypes: []})
        }),
          catchError((error: any) => of(AppendixTypesError()))
        ) 
      )
    )
  );

  onError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppendixesError),
      tap(() => console.error('Error'))
    ),
    { dispatch: false }
  );

  onErrorTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppendixTypesError),
      tap(() => console.error('Error'))
    ),
    { dispatch: false }
  );
}
